import { inject, injectable } from 'inversify';
import React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

import { ReactHookServicePort } from '../../../../shared/core/port/React.hook.service.port';
import { UserServiceController } from '../../../User/infrastructure/controllers/User.service.controller';
import {
  IUserCreationForm,
  IUserHookFactory,
  TUseUserCreator,
} from '../../domain/interfaces';

@injectable()
export class UserHookFactory implements IUserHookFactory {
  constructor(
    @inject(ReactHookServicePort)
    private readonly reactHookServicePort: ReactHookServicePort,

    @inject(UserServiceController)
    private readonly userServiceController: UserServiceController,
  ) {}

  public composeUseUserCreator(): TUseUserCreator {
    return ({ userPrincipal, featureFlags, actions }) => {
      const userFormCreatorHandler = async (
        userFormCreator: IUserCreationForm,
      ) => {
        return this.userServiceController.createUser(userPrincipal, {
          userFormCreator,
          featureFlags,
        });
      };

      return this.reactHookServicePort.composeUseApiRequestWrapper()(
        userFormCreatorHandler,
        {
          manifestToast: {
            handleSuccess: ({ user }) => {
              const { givenName, familyName } = user.toSerializedModel();
              const userFullName = `${givenName} ${familyName}`;

              return [
                `Added ${userFullName}`,
                {
                  description: `${userFullName} was added to ${userPrincipal.companyName}`,
                  variant: 'success',
                  action: (
                    <ManifestUI.ButtonGroup
                      children={actions.map((buttonProps, index) => {
                        return (
                          <ManifestUI.Button
                            key={index.toString()}
                            {...buttonProps}
                          />
                        );
                      })}
                    />
                  ),
                },
              ];
            },
            handleError: (fetchError) => [fetchError.message],
          },
        },
      );
    };
  }
}
